import styled, { css } from "styled-components"
import { down } from "styled-breakpoints"

export const Container = styled.div`
  width: 100%;
  //padding-right: 15px;
  //padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  max-width: 1600px;

  ${down("lg")} {
    max-width: 1200px;
  }

  ${down("md")} {
    max-width: 960px;
  }

  ${down("sm")} {
    max-width: 720px;
  }

  ${down("xs")} {
    max-width: 540px;
  }
`

export const ContainerMob = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  max-width: 1600px;
  position: relative;
  z-index: 10;
  align-items: ${props => props.align || "unset"};
  margin-top: ${props => props.mt || "0rem"};
  margin-bottom: ${props => props.mb || "0rem"};

  ${down("lg")} {
    max-width: 1200px;
  }

  ${down("md")} {
    max-width: 960px;
  }

  ${down("sm")} {
    margin-top: ${props => props.mtMobile || "0rem"};
    max-width: 720px;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  ${down("xs")} {
    max-width: 540px;
    padding-right: 1rem;
    padding-left: 1rem;
  }
`

export const ContainerHalf = styled.div`
  width: 100%;
  margin-right: 0;
  margin-left: auto;
  max-width: 800px;

  ${down("lg")} {
    max-width: 600px;
  }

  ${down("md")} {
    max-width: 480px;
  }

  ${down("sm")} {
    max-width: 360px;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  ${down("xs")} {
    max-width: 540px;
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
`

export const CardWrapper = styled(Container)`
  display: grid;
  padding-left: 0;
  padding-right: 0;
  grid-column-gap: ${props => props.colGap || "2rem"};
  grid-row-gap: ${props => props.rowGap || "2rem"};
  margin-top: ${props => props.mt || "2rem"};
  margin-bottom: ${props => props.mb || "2rem"};
  grid-template-columns: repeat(3, 1fr);
  grid-template-columns: repeat(${props => props.xl || 4}, 1fr);

  ${down("lg")} {
    grid-template-columns: repeat(${props => props.l || 4}, 1fr);
  }

  ${down("md")} {
    grid-template-columns: repeat(${props => props.m || 4}, 1fr);
  }

  ${down("sm")} {
    grid-template-columns: repeat(${props => props.s || 2}, 1fr);
  }

  ${down("xs")} {
    grid-template-columns: repeat(${props => props.xs || 1}, 1fr);
  }
`

export const CardWrapperMob = styled(ContainerMob)`
  display: grid;
  column-gap: ${props => props.colGap || "0"};
  row-gap: ${props => props.rowGap || "0"};
  margin-top: ${props => props.mt || "0rem"};
  margin-bottom: ${props => props.mb || "0rem"};
  padding-top: ${props => props.pt || "0"};
  padding-bottom: ${props => props.pb || "0"};
  grid-template-columns: repeat(3, 1fr);
  grid-template-columns: repeat(${props => props.xl || 5}, 1fr);

  ${down("lg")} {
    grid-template-columns: repeat(${props => props.l || 4}, 1fr);
  }

  ${down("md")} {
    grid-template-columns: repeat(${props => props.m || 3}, 1fr);
  }

  ${down("sm")} {
    grid-template-columns: repeat(${props => props.s || 2}, 1fr);
  }

  ${down("xs")} {
    grid-template-columns: repeat(${props => props.xs || 1}, 1fr);
  }
`

export const Wrapper = styled.div`
  display: grid;
  padding-left: 0;
  padding-right: 0;
  grid-column-gap: ${props => props.colGap || "2rem"};
  grid-row-gap: ${props => props.rowGap || "2rem"};
  margin-top: ${props => props.mt || "2rem"};
  margin-bottom: ${props => props.mb || "2rem"};
  grid-template-columns: repeat(${props => props.xl || 4}, 1fr);

  ${down("lg")} {
    grid-template-columns: repeat(${props => props.l || 4}, 1fr);
  }

  ${down("md")} {
    grid-template-columns: repeat(${props => props.m || 4}, 1fr);
  }

  ${down("sm")} {
    grid-template-columns: repeat(${props => props.s || 2}, 1fr);
  }

  ${down("xs")} {
    grid-template-columns: repeat(${props => props.xs || 1}, 1fr);
  }
`

export const Section = styled.section`
  padding-top: ${props => props.pt || "6rem"};
  padding-bottom: ${props => props.pb || "6rem"};
  background-color: ${props => props.bgColor || "transparent"};
  h2 {
    margin-bottom: 2rem;
  }
`

export const Section2 = styled.section`
  padding-top: ${props => `${props.pt}rem` || "0rem"};
  padding-bottom: ${props => `${props.pb}rem` || "0rem"};
  background-color: ${props => props.bgcolor || "transparent"};
  position: relative;
  margin-top: ${props => props.mt || "0"};
  margin-bottom: ${props => props.mb || "0"};

  ${down("lg")} {
    padding-top: ${props => `${props.pt}rem` || "0rem"};
    padding-bottom: ${props => `${props.pb}rem` || "0rem"};
  }

  ${down("md")} {
    padding-top: ${props => `${props.pt}rem` || "0rem"};
    padding-bottom: ${props => `${props.pb}rem` || "0rem"};
  }

  ${down("sm")} {
    padding-top: ${props => `${props.pt - 3}rem` || "0rem"};
    padding-bottom: ${props => `${props.pb}rem` || "0rem"};
  }

  ${down("xs")} {
    padding-top: ${props => `${props.pt - 4}rem` || "0rem"};
    padding-bottom: ${props => `${props.pb}rem` || "0rem"};
  }
`

const variantOptions = {
  left: {
    bgColor: props => props.theme.color.base6,
    direction: "ltr",
  },
  right: {
    bgColor: props => props.theme.color.base3,
    direction: "rtl",
  },
}

export const ProductWrapper = styled(Section)`
  > div {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    max-width: 1600px;
    position: relative;
    z-index: 10;
    margin-top: ${props => props.mt || "0rem"};
    margin-bottom: ${props => props.mb || "0rem"};

    display: grid;
    grid-template-columns: 15fr 10fr;
    column-gap: 3rem;

    ${down("lg")} {
      max-width: 1200px;
    }

    ${down("md")} {
      max-width: 960px;
    }

    ${down("sm")} {
      margin-top: ${props => props.mtMobile || "0rem"};
      max-width: 720px;
      padding-right: 1rem;
      padding-left: 1rem;
    }

    ${down("xs")} {
      max-width: 540px;
      padding-right: 1rem;
      padding-left: 1rem;
      grid-template-columns: 1fr;
    }

    span {
      display: flex;
      flex-direction: column;
      > div {
        justify-self: start;
        align-self: flex-start;
        width: 100%;
        height: 100%;
      }
      div {
        justify-content: start;
      }
    }
  }

  ${({ variant }) =>
    variant &&
    variantOptions[variant] &&
    css`
      background-color: ${variantOptions[variant].bgColor};
      > div {
        direction: ${variantOptions[variant].direction};
        ul,
        p {
          direction: ltr;
        }

        ${down("xs")} {
          direction: unset;
        }
      }
    `}
`
